
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./CorrosionInhibition.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";

import { trackPageVisit } from "../competency/PageTracker";





      // ================= MIXING IMPELLER COMPONENT =================
function MixingTankImpeller({
  x = 200,
  y = 200,
  size = 100,
  bladeCount = 6,
  speed = 2,
  isP2971On = false
}) {
  const [angle, setAngle] = useState(0);

  useEffect(() => {
    if (!isP2971On) return;

    const interval = setInterval(() => {
      setAngle(prev => (prev + speed) % 360);
    }, 30);

    return () => clearInterval(interval);
  }, [isP2971On, speed]);

  const blades = [];

  for (let i = 0; i < bladeCount; i++) {
    const rotation = (360 / bladeCount) * i;

    blades.push(
      <rect
        key={i}
        x={-5}
        y={-size / 2}
        width={10}
        height={size / 2}
        fill="#555"
        rx="2"
        transform={`rotate(${rotation})`}
      />
    );
  }

  return (
    <g transform={`translate(${x}, ${y}) rotate(${angle})`}>
      <circle r={8} fill="#222" />
      {blades}
    </g>
  );
}
 

 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function CorrosionInhibition() {

  useEffect(() => {

  trackPageVisit("CorrosionInhibition");

}, []);


   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);


  


  const DEFAULT_VALVES = {
  FCV_2971: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("CorrosionInhibition_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2971: { ...DEFAULT_VALVES.FCV_FCV_2971, ...parsed.FCV_2971 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("CorrosionInhibition_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





// ================= WATER RATIO FOR MIXING =================
const [H2O_2971, setH2O_2971] = useState(() => {
  return Number(localStorage.getItem("H2O_2971")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("H2O_2971", H2O_2971);
}, [H2O_2971]);

const [h2o2971Position, setH2o2971Position] = useState({ x: 327, y: 316 }); // 🔧 adjust freely


// ================= CIH_2971 (FOULING FACTOR - SEAWATER STRAINER) =================
const [CIH_2971, setCIH_2971] = useState(() => {
  return Number(localStorage.getItem("CIH_2971")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("CIH_2971", CIH_2971);
}, [CIH_2971]);

const [cih2971Position, setCih2971Position] = useState({ x: 327, y: 336 }); // 🔧 adjust freely



// ================= VALVE AND PUMPS INITIALIZATION AND STATUS =================
  const isXV2971Open = valves?.XV_2971 === false;
  const isXV2972Open = valves?.XV_2972 === false;
  const isXV2973Open = valves?.XV_2973 === false;
  const isXV2974Open = valves?.XV_2974 === false;

  const isP2971On = pumpData?.["P-2971"]?.running ?? false;
  const isP2972On = pumpData?.["P-2972"]?.running ?? false;

  const isP2973AOn = pumpData?.["P-2973A"]?.running ?? false;
  const isP2973BOn = pumpData?.["P-2973B"]?.running ?? false;

    const FIC_2971 = isXV2971Open ? 100 * CIH_2971/100 : 0;
    const FIC_2972 = isXV2972Open ? 100 * H2O_2971/100 : 0;
    const FIC_2973 = isXV2973Open ? 50 : 0;

    const PT_2971 = isP2971On ? 0.1 : 0.03;





    
  // ================= CORROSION INHIBITOR MIXING PUMPS =================

const runningPumps2971 = [isP2971On].filter(Boolean).length;


    
  // ================= CORROSION INHIBITOR TRANSFER PUMPS =================

const runningPumps2972 = [isP2972On].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow2971 = 0;
const suctionPressure2971 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2971 =  1.3;
const MIN_DISCH_PRESSURE_2971 = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_2972 = MIN_DISCH_PRESSURE_2971;
let targetFIC_2974 = 0;

if (runningPumps2972 > 0) {

  // 🔹 Flow boost
  targetFIC_2974 = 50;

  // 🔹 Pressure rises to design max
  targetPT_2972 = MAX_DISCH_PRESSURE_2971;

}

// ================= STATES =================
const [PT_2972, setPT_2972] = useState(() => {
  return Number(localStorage.getItem("PT_2972")) || 0.03;
});

const [FIC_2974, setFIC_2974] = useState(() => {
  return Number(localStorage.getItem("FIC_2974")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2972(prev => {
      const next = prev + (targetPT_2972 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2974(prev => {
      const next = prev + (targetFIC_2974 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_2972, targetFIC_2974]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2972", PT_2972);
}, [PT_2972]);

useEffect(() => {
  localStorage.setItem("FIC_2974", FIC_2974);
}, [FIC_2974]);




const PT_2973 = isXV2974Open ? 0.4 : 0;




  // ================= MAIN CORROSION INHIBITION INJECTION PUMPS =================
  const runningPumps2973 = [isP2973AOn, isP2973BOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow2973 = 0;
const suctionPressure2973 = PT_2973;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2973 = PT_2973 * 3.5;
const MIN_DISCH_PRESSURE_2973 = 0.03;

// ================= TARGET CALCULATIONS =================
let targetPT_2974 = MIN_DISCH_PRESSURE_2973;
let targetFIC_2975 = 0;

if (runningPumps2973 > 0) {

  // 🔹 Flow boost
  targetFIC_2975 = isXV2974Open ? 50 * (valveData?.FCV_2971?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_2974 = isXV2974Open ? MAX_DISCH_PRESSURE_2973 * (1 - ((10/100) * (valveData?.FCV_2971?.opening || 0)/100)) : 0.03;

}

// ================= STATES =================
const [PT_2974, setPT_2974] = useState(() => {
  return Number(localStorage.getItem("PT_2974")) || 0.03;
});

const [FIC_2975, setFIC_2975] = useState(() => {
  return Number(localStorage.getItem("FIC_2975")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2974(prev => {
      const next = prev + (targetPT_2974 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2975(prev => {
      const next = prev + (targetFIC_2975 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_2974, targetFIC_2975]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2974", PT_2974);
}, [PT_2974]);

useEffect(() => {
  localStorage.setItem("FIC_2975", FIC_2975);
}, [FIC_2975]);

// ================= LOAD SHARING (OPTIONAL DISPLAY) =================
const loadShare2951 =
  runningPumps2973 > 0 ? (100 / runningPumps2973).toFixed(0) : 0;

// Example (if you want to display per pump later):
const pumpAFlow =
  isP2973AOn && runningPumps2973 > 0
    ? FIC_2975 / runningPumps2973
    : 0;

const pumpBFlow =
  isP2973BOn && runningPumps2973 > 0
    ? FIC_2975 / runningPumps2973
    : 0;







    // ================= CORROSION INHIBITION CONCENTRATION TRAMSMITTER OUTPUT =================
// ================= INPUTS =================
const CI_flow = Number(FIC_2971 || 0);
const H2O_flow = Number(FIC_2972 || 0);


// TRUE when blending is active
const isBlending = isXV2971Open || isXV2972Open;

// ================= RAW PPM =================
const rawPPM = CI_flow * 10000;

// ================= DILUTION MODEL =================
let dilutionFactor = 1;

if (H2O_flow > 0) {
  const ratio = CI_flow / (CI_flow + H2O_flow);
  const exponent = 3.5;
  dilutionFactor = Math.pow(ratio, exponent);
}

const calculatedICT = rawPPM * dilutionFactor;

// ================= HOLD STATE (KEY ADDITION) =================
const [ICT_2971, setICT_2971] = useState(0);

// store last valid value before shutdown
const [lastICT, setLastICT] = useState(0);

// ================= DCS BEHAVIOR =================
useEffect(() => {

  // IF BLENDING ACTIVE → UPDATE NORMAL
  if (isBlending) {

    const interval = setInterval(() => {

      setICT_2971(prev => {
        const next = prev + (calculatedICT - prev) * 0.15;
        const val = Number(next.toFixed(2));

        // keep last known good value updated
        setLastICT(val);

        return val;
      });

    }, 500);

    return () => clearInterval(interval);
  }

  // IF BLENDING STOPPED → HOLD LAST VALUE
  else {
    setICT_2971(lastICT);
  }

}, [isBlending, calculatedICT, lastICT]);










// ================= INPUTS =================
const ICT_2971_value = Number(ICT_2971 || 0);

const FIC_2973_value = Number(FIC_2973 || 0);

// ================= STATE (TRANSFER TANK MEMORY) =================
const [ICT_2972, setICT_2972] = useState(0);
const [frozenICT, setFrozenICT] = useState(0);
const [prevPumpState, setPrevPumpState] = useState(false);

// ================= LOGIC =================
useEffect(() => {

  // 🔵 DETECT PUMP RISING EDGE (OFF → ON)
  const pumpJustTurnedOn = isP2972On && !prevPumpState;

  // 🔴 WHEN PUMP TURNS ON → CAPTURE ICT_2971
  if (pumpJustTurnedOn) {
    setFrozenICT(ICT_2971_value);
  }

  // 🟢 ALWAYS UPDATE PREVIOUS STATE
  setPrevPumpState(isP2972On);

  // ================= DILUTION FACTOR =================
  let dilutedValue = frozenICT;

  if (isXV2973Open && FIC_2973_value > 0) {
    // mild dilution effect
    const dilutionStrength = Math.min(FIC_2973_value / 100, 0.3);

    dilutedValue = frozenICT * (1 - dilutionStrength);
  }

  // ================= UPDATE OUTPUT =================
  setICT_2972(dilutedValue);

}, [
  ICT_2971_value,
  isP2972On,
  isXV2973Open,
  FIC_2973_value,
  frozenICT,
  prevPumpState
]);










  return (
    <div className="CorrosionInhibition-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "252px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 290px"
      }}>
        CORROSION INHIBITION
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-2971"
        tag="XV_2971"
        x={220}
        y={122}
        isClosed={valves.XV_2971}
        toggle={toggleValve}
      />

      {/* XV-2972 */}
      <Valve
        className="XV-2972"
        tag="XV_2972"
        x={413}
        y={122}
        isClosed={valves.XV_2972}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2973 */}
      <Valve
        className="XV-2973"
        tag="XV_2973"
        x={839}
        y={116}
        isClosed={valves.XV_2973}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2974 */}
      <Valve
        className="XV-2974"
        tag="XV_2974"
        x={1184}
        y={396}
        isClosed={valves.XV_2974}
        toggle={toggleValve}
        r={90}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2971 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2971"
          style={{ position: "absolute", left: 377, top: 592}}  onClick={() => openPanel("FCV_2971")}>
          
          <defs>
            <linearGradient id="metal_2971">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2971)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2971)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* ================= IMPELLER (INSIDE TANK) ================= */}
      <svg width="500" height="400" style={{ position: "absolute", left: 300, top: 200 }}>

        <MixingTankImpeller
          x={176}
          y={150}
          size={80}
          bladeCount={6}
          speed={3}
          isP2971On={isP2971On}
        />

      </svg>

      <div
          style={{
            position: "absolute",
            left: 213,   // 🔧 adjust position
            top: 288,    // 🔧 adjust position
            color: isP2971On ? "lime" : "red",
            fontWeight: "bold",
            fontSize: "14px",
            background: "rgba(0,0,0,0.6)",
            padding: "2px 4px",
            borderRadius: "4px"
          }}
        >
          {isP2971On ? "MIXING ONGOING" : "MIXING STOPPED"}
        </div>



          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2971?.opening || 0)}
        x={395}
        y={642}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
          tag="FIC-2971"
          value={[FIC_2971]}
          x={129}
          y={182}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF EPICOOL 2000 WATER-BASED CORROSION INHIBITOR INTO THE CORROSION INHIBITION MIXING TANK"
        />
      <Transmitter
          tag="FIC-2972"
          value={[FIC_2972]}
          x={334}
          y={121}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF WATER INTO THE CORROSION INHIBITION MIXING TANK "
        />
      <Transmitter
          tag="FIC-2973"
          value={[FIC_2973]}
          x={773}
          y={171}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF WATER INTO THE CORROSION INHIBITION TRANSFER TANK FOR FURTHER DILUTION"
        />

        <Transmitter
          tag="PT-2971"
          value={PT_2971}
          x={465}
          y={440}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED WATER-BASED CORROSION INHIBITION SOLUTION AT THE DISCHARGE OF MIXING TANK TO TRANSFER PUMP"
        />
        <Transmitter
          tag="PT-2972"
          value={PT_2972}
          x={727}
          y={408}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED WATER-BASED CORROSION INHIBITION SOLUTION AT THE DISCHARGE OF MIXING TANK TO TRANSFER PUMP"
        />

        <Transmitter
          tag="FIC-2974"
          value={[FIC_2974]}
          x={727}
          y={471}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF WATER INTO THE CORROSION INHIBITION TRANSFER TANK FOR FURTHER DILUTION"
        />      
        <Transmitter
          tag="FIC-2975"
          value={[FIC_2975]}
          x={574}
          y={595}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF WATER-BASED CORROSION INHIBITION TO CORROSION INHIBITION HEADER"
        />

        <Transmitter
          tag="PT-2974"
          value={PT_2974}
          x={659}
          y={595}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED SOLUTION OF WATER-BASED CORROSION INHIBITION TO CORROSION INHIBITION HEADER"
        />      
        <Transmitter
          tag="PT-2973"
          value={PT_2973}
          x={1204}
          y={469}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF MIXED SOLUTION OF WATER-BASED CORROSION INHIBITION FROM TRANSFER TANK TO CORROSION INHIBITION INJECTION PUMP"
        />      















      <Transmitter
          tag="H2O-2971"
          value={[H2O_2971]}
          x={279}
          y={312}
          unit="%"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="PERCENTAGE OF WATER USED FOR BLENDING WITH WATERBASED CORROSION INHIBITOR"
        />
      <Transmitter
          tag="CIH-2971"
          value={[CIH_2971]}
          x={279}
          y={332}
          unit="%"
          max={30}
          HH={25}
          H={20}
          L={10}
          LL={5}
          c="lime"
          description="PERCENTAGE OF WATER-BASED CORROSION INHIBITOR USED FOR BLENDING WITH WATER IN MIXING TANK"
        />

      <Transmitter
          tag="ICT-2971"
          value={[ICT_2971]}
          x={569}
          y={339}
          unit="ppm"
          max={50}
          HH={45}
          H={40}
          L={8}
          LL={5}
          c="lime"
          description="Real-time monitoring of parts-per-million (ppm) levels to ensure the mixing ratio stays within effective ranges (typically 5 - 50 ppm for continuous dosing) in Mixing Tank"
        />
      <Transmitter
          tag="ICT-2972"
          value={[ICT_2972]}
          x={1042}
          y={339}
          unit="ppm"
          max={50}
          HH={45}
          H={40}
          L={8}
          LL={5}
          c="lime"
          description="Real-time monitoring of parts-per-million (ppm) levels to ensure the mixing ratio stays within effective ranges (typically 5 - 50 ppm for continuous dosing) in Transfer Tank"
        />























                <div
                  className="h2o2971-input-group"
                  style={{
                    position: "absolute",
                    left: h2o2971Position.x,
                    top: h2o2971Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="h2o2971-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={H2O_2971}
                    onChange={(e) => setH2O_2971(Number(e.target.value) || 0)}
                  />
                </div>
                
                
                <div
                  className="cih2971-input-group"
                  style={{
                    position: "absolute",
                    left: cih2971Position.x,
                    top: cih2971Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="cih2971-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={CIH_2971}
                    onChange={(e) => setCIH_2971(Number(e.target.value) || 0)}
                  />
                </div>





                
      <Pump
        tag="P-2971"
        x={456}
        y={122}
        rpm={1800}
        bladeCount={pumpData?.["P-2971"]?.bladeCount || 0}
        size={pumpData?.["P-2971"]?.size || 40}
        onClick={openPumpPanel}
      />
          
                
      <Pump
        tag="P-2972"
        x={624}
        y={440}
        rpm={1800}
        bladeCount={pumpData?.["P-2972"]?.bladeCount || 6}
        size={pumpData?.["P-2972"]?.size || 35}
        onClick={openPumpPanel}
      />

      <Pump
        tag="P-2973A"
        x={940}
        y={524}
        rpm={1800}
        bladeCount={pumpData?.["P-2973A"]?.bladeCount || 6}
        size={pumpData?.["P-2973A"]?.size || 35}
        onClick={openPumpPanel}
      />
      <Pump
        tag="P-2973B"
        x={939}
        y={646}
        rpm={1800}
        bladeCount={pumpData?.["P-2973B"]?.bladeCount || 6}
        size={pumpData?.["P-2973B"]?.size || 35}
        onClick={openPumpPanel}
      />

    
          
      <LevelTransmitterIndicator
      tag="LT_2971"
      totalLevel={100000}
      inflows={[FIC_2971 + FIC_2972]}
      outflows={[FIC_2974]}
      responseFactor={0.05}
      columnX={358}
      columnY={230}
      columnWidth={195}
      columnHeight={166}
      textX={569}
      textY={218}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />
      <LevelTransmitterIndicator
      tag="LT_2972"
      totalLevel={150000}
      inflows={[FIC_2974 + FIC_2973]}
      outflows={[FIC_2975]}
      responseFactor={0.05}
      columnX={838}
      columnY={230}
      columnWidth={179}
      columnHeight={166}
      textX={1039}
      textY={218}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />
           



    </div>
  );
}


export default CorrosionInhibition;